import { addYears as addYearsFns, differenceInYears as differenceInYearsFns } from 'date-fns';
/**
 * Adds a number of years to a date
 *
 * @param {Date} date - The date to use for adding the years to.
 * @param {number} amount - The number of years to add.
 * @returns {Date} - The new date with the years added.
 */
export const addYears = (date, amount) => addYearsFns(date, amount);
/**
 * Get the number of full years between the given dates.
 *
 * @param {Date} dateLeft -
 * @param {Date} dateRight -
 * @returns {number} - The number of full years.
 */
export const differenceInYears = (dateLeft, dateRight) => differenceInYearsFns(dateLeft, dateRight);
//# sourceMappingURL=year-helpers.js.map